import { v4 as uuidv4 } from 'uuid';

interface ScreenshotResponse {
    screenCaptureData: string;
    referenceId: string;
}

export const requestScreenshotAsync = (
    selectedSourceId: string,
    sessionId: string,
    timeoutMs: number = 5000,
): Promise<ScreenshotResponse> => {
    return new Promise((resolve, reject) => {
        let settled = false;
        const requestId = `${sessionId}:${uuidv4()}`;
        let unsubscribe: () => void = () => {};

        const cleanup = () => {
            clearTimeout(timeoutId);
            unsubscribe();
        };

        const timeoutId = setTimeout(() => {
            if (settled) return;
            settled = true;
            cleanup();
            reject(new Error(`Screenshot request timed out after ${timeoutMs} ms`));
        }, timeoutMs);

        const handleResponse = (screenCaptureData: string, referenceId: string) => {
            if (settled || referenceId !== requestId) return;
            settled = true;
            cleanup();
            resolve({ screenCaptureData, referenceId });
        };

        const listenerCleanup = window.electronApi.onScreenshotResponse(handleResponse);
        unsubscribe = typeof listenerCleanup === 'function' ? listenerCleanup : () => {};

        try {
            void window.electronApi
                .requestScreenshot(selectedSourceId, requestId)
                .catch((error) => {
                    if (!settled) {
                        settled = true;
                        cleanup();
                        reject(error);
                    }
                });
        } catch (error) {
            if (!settled) {
                settled = true;
                cleanup();
                reject(error);
            }
        }
    });
};
